import { registerOrder } from '_api/activity-common-template'
import { showMessage, executeProtocol } from '_lib/utils'

export default {
  methods: {
    registerOrder (award) {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      if ([-1, 0].includes(award.collect_state) || !award.eligibility_data) {
        return
      }
      if (this.registerLock) {
        return
      }
      this.registerLock = true
      let params = {
        client_type: ''
      }
      let data = {
        session: this.gd.session,
        buy_type: award.eligibility_data.buy_type,
        act_id: this.querys.act_id,
        item_id: award.item_id,
        params: [{
          count: 1,
          cat_value: award.eligibility_data.cat_value,
          sku_id: award.eligibility_data.sku_id,
          buy_type: award.eligibility_data.buy_type
        }]
      }
      if (award.eligibility_data.appid) {
        data.appid = award.eligibility_data.appid
        params.appid = award.eligibility_data.appid
      }
      if (award.eligibility_data.package_id) {
        data.package_id = award.eligibility_data.package_id
      }
      registerOrder(params, {
        data: JSON.stringify(data)
      }).then((res) => {
        this.registerLock = false
        if (res.data.status == 'ok') {
          this.$parent.reload()
          const data = res.data.result
          let order_id = String(data.order_id)
          
          if (data.not_finish_order == 1) {
            executeProtocol({
              protocol_type: 'alert',
              title: '购买失败',
              desc: '当前有订单尚未完成，是否前往',
              alert_type: "confirm",
              protocol: {
                protocol_type: 'evaluateJS',
                jsfunc: `openOrder(${order_id})`
              }
            })
          } else {
            this.$parent.openOrderDetail(order_id)
          }
        }
      }).catch((err) => {
        this.registerLock = false
        console.log('[error]', err)
        showMessage('failed', '网络错误！')
      })
    }
  }
}